__turbopack_context__.v({
  "className": "roboto_d806cae8-module__UIfAqW__className",
});
